import * as React from 'react';
type SelectortCategoriesPropTypes = {
  register: any;
  selectedCategories: Array<string>;
  name: string;
  label: string;
};
export const BlogPostSelectCategories = ({
  register,
  selectedCategories,
  name,
  label,
}: SelectortCategoriesPropTypes) => {
  const defaultCategoryList: Array<string> = [
    'Non League News',
    'FA Comps',
    'FA Vase',
    'FA Trophy',
    'FA Cup',
  ];
  return (
    <div>
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor={name}
      >
        {label}
      </label>
      <div className="flex flex-row">
        {defaultCategoryList.map((a, b) => (
          <>
            <label className="pr-1 pl-1">{a}</label>
            <input
              checked={
                selectedCategories.find(
                  e => e.toLowerCase() === a.toLowerCase(),
                ) !== undefined
                  ? 'checked'
                  : null
              }
              id={name}
              name={name}
              type="checkbox"
              value={a.toLowerCase()}
              key={b}
              {...register(name)}
            />
          </>
        ))}
      </div>
    </div>
  );
};

/*
checked={
                selectedCategories.find(
                  e => e.toLowerCase() === a.toLowerCase(),
                ) !== undefined
              }
              */
